/**
 * グローバル変数ファイル
 */

window.MANAGIMENT_OFFICE_NAME = '求人ガイド事務局';
window.MESSAGE_FROM_COMPANY = 1;
window.MESSAGE_FROM_USER = 2;
window.MESSAGE_FROM_SYSTEM_TO_USER = 3;
window.MESSAGE_FROM_SYSTEM_TO_COMPANY = 4;
